/* */ 
"use strict";
var Subscriber_1 = require('../Subscriber');
var rxSubscriber_1 = require('../symbol/rxSubscriber');
function toSubscriber(nextOrObserver, error, complete) {
  if (nextOrObserver && typeof nextOrObserver === 'object') {
    if (nextOrObserver instanceof Subscriber_1.Subscriber) {
      return nextOrObserver;
    } else if (typeof nextOrObserver[rxSubscriber_1.$$rxSubscriber] === 'function') {
      return nextOrObserver[rxSubscriber_1.$$rxSubscriber]();
    }
  }
  return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
